<div class="p-6 flex-table-page">
  <!-- Header -->
  <h2 class="text-2xl font-semibold text-gray-800 mb-3 flex-table-header">
    {{ "sync_report.header" | translate }}
  </h2>

  <!-- Search Form -->
  <app-search-form
    [searchFormat]="searchConfig"
    (formSearch)="onSearch($event)"
    (formReset)="onReset()"
  ></app-search-form>

  <!-- Data Table -->
  <div class="table-section flex-table-section">
    <advanced-data-table
      [dataSource]="syncLogs()"
      [defaultColumns]="columns"
      [flexibleColumns]="[]"
      [loading]="loading()"
      [rows]="pageSize()"
      [first]="(currentPage() - 1) * pageSize()"
      [totalRecords]="totalRecords()"
      [hasCheckColumn]="false"
      (pageChange)="onPageChange($event)"
      [showInternalColumnConfigButton]="false"
      scrollHeight="flex"
      class="w-full"
    >
      <ng-template
        #customTemplate
        let-value
        let-rowData="rowData"
        let-column="column"
      >
        @if (column && column.template === "dateTemplate") {
          <span class="text-xs text-gray-600">
            {{ formatDateTime(value) }}
          </span>
        } @else if (column && column.template === "eventTypeTemplate") {
          @if (value) {
            <span class="text-sm">{{ eventTypeI18nKey(value) | translate }}</span>
          }
        } @else if (column && column.template === "resultTemplate") {
          @if (value === "FAILURE") {
            <span class="text-sm text-red-600">{{
              resultI18nKey(value) | translate
            }}</span>
          } @else if (value === "SUCCESS") {
            <span class="text-sm text-green-700">{{
              resultI18nKey(value) | translate
            }}</span>
          } @else if (value) {
            <span class="text-sm">{{ resultI18nKey(value) | translate }}</span>
          }
        } @else if (column && column.template === "operationTemplate") {
          @if (value) {
            <span class="text-sm">{{ operationI18nKey(value) | translate }}</span>
          }
        } @else if (column && column.prop === "errorReason") {
          @if (value) {
            <span class="text-sm text-red-600" [title]="value">{{
              value
            }}</span>
          } @else {
            <span class="text-gray-400 italic">{{
              "sync_report.values.no_error" | translate
            }}</span>
          }
        }
      </ng-template>
    </advanced-data-table>
  </div>
</div>

<!-- Toast Messages -->
<p-toast></p-toast>
